import { withStyles } from '@material-ui/core';

import ParagraphBlock from './component';
import styles from './styles';

export default withStyles(styles)(ParagraphBlock);
